import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReprintService {

  constructor(
    private http: HttpClient
  ) { }


  public getAll(productId?:number): Observable<any>{

    if(Number(productId) >0){
      return this.http.get<any>(`reprint/${productId}/all`)
    }else{
      return EMPTY
    }
  }

  public remove(productId:Number, reprintId:number): Observable<any>{
    return this.http.delete(`reprint/${productId}/${reprintId}`)
  }

  public get(productId:number, reprintId:number): Observable<any>{
    return this.http.get<any>(`reprint/${productId}/${reprintId}`);
  }
}
